import { useState } from 'react'

import { DebugPanel } from './components/DebugPanel'
import { RibbonCanvas } from './components/RibbonCanvas'
import { RibbonScene } from './ribbon/RibbonScene'

export default function App(): React.JSX.Element {
  const [controller, setController] = useState<RibbonScene | null>(null)

  return (
    <main className="app-shell">
      <RibbonCanvas onController={setController} />
      <DebugPanel controller={controller} />
      <div className="scroll-track" aria-hidden="true" />
      <p className="visually-hidden" aria-live="polite">
        Interactive WebGL fabric ribbon study. Scroll the page to move from the
        beginning to the end of the deformation.
      </p>
    </main>
  )
}
